import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'


Vue.config.productionTip = false
axios.defaults.withCredentials = true;

import Vuex from 'vuex'
Vue.use(Vuex)

import VueCookie from 'vue-cookie'
Vue.use(require('vue-cookie'))

import VCharts from 'v-charts'
Vue.use(VCharts)

import { store } from './store/store.js';
new Vue({
    vuetify,
    router,
    store,
    
    render: h => h(App)
}).$mount('#app')


function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');

    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

router.beforeEach((to, from, next) => {

    // if(from.path != '/login'){
    //     next('/login')
    // }
    let check_has_bot = localStorage.getItem('has_bot')
    let check_link_bot = localStorage.getItem('has_link_bot')

    const role = getCookie('access_token');
    if(!role && to.path !== '/login'){
        next('/login')
    }        
    else if(check_has_bot == 'true' && check_link_bot == 'false' && to.path !== '/chat_bot'){
        next('/chat_bot')
    }
    else{ 
        next()
    }
        
})

axios.interceptors.request.use((config) => {
    const role = getCookie('access_token');

    if(!role)
        router.push('/login')
   
    var expire = getCookie('expires')
   
    if(expire == null)
    {
        router.push('/login')
        // }
        // else {
        //     router.push('/signup')
        // }
        // return
    }

    ///////////////////////////////////////////////////////
    var expires_time = new Date(getCookie('expires'))
    expires_time.setHours(expires_time.getHours()-1);

    var EXPIRATION_DELTA_HOURS = Number(process.env.VUE_APP_EXPIRATION_DELTA_HOURS)

    if(new Date()>expires_time)
    {

        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;

        xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
            var tmp = JSON.parse(xhr.responseText)
            
            // var addnow = new Date();
            // addnow.setHours(addnow.getHours()+Number(process.env.VUE_APP_EXPIRATION_DELTA_HOURS))
            // document.cookie = "access_token="+String(tmp.token)+"; expires="+addnow.toUTCString();
            // document.cookie = "expires="+addnow.toUTCString()+"; expires="+addnow.toUTCString();
            // localStorage.setItem('account_name', tmp.account_name)

            var addnow = new Date();
            addnow.setHours(addnow.getHours()+EXPIRATION_DELTA_HOURS)

            document.cookie = "access_token="+String(tmp.token)+"; expires="+addnow.toUTCString();
            document.cookie = "expires="+addnow.toUTCString()+"; expires="+addnow.toUTCString();
            // document.cookie = "ly_code2=" + this.code + ";expires=" + new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)).toUTCString() + ";domain=devbackend425.lychee.pro";
            localStorage.setItem('account_type', tmp.account_type)
            localStorage.setItem('vendor_id', tmp.vendor_id)
            localStorage.setItem('account_name', tmp.account_name)
            localStorage.setItem('has_bot', tmp.has_bot)
            localStorage.setItem('has_link_bot', tmp.has_link_bot)
            }
        });

        xhr.addEventListener("error", ()=>{
            // this.$ga.event('main', 'axios_interceptors', 'Error')
        });
        xhr.open("POST", process.env.VUE_APP_HOST_URL+"token-refresh/");
        xhr.setRequestHeader("Content-Type", "application/json");
        // xhr.setRequestHeader("X-CSRFToken", getCookie('csrftoken'));
        xhr.send(null);
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});